
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from "react-redux"
import { obtenerDevolucionesPendientesPaginaAction, obtenerDevolucionesPendientesRegistrosAction } from "./../../../ducks/devolucionesDuck"
import ButtonClienteDetalle from "./../../../global/ButtonClienteDetalle"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import ButtonDowloadEstadoCueta from "./ButtonDowloadEstadoCueta"
import ButtonAceptarDevolucion from "./ButtonAceptarDevolucion"
import ButtonDeclinarRembolso from "./ButtonDeclinarRembolso"
import DialogMensaje from "./DialogMensaje"
import { FormatoFechaIso } from "./../../../utils/FormatFecha"
import { catEstatusCatEstatusDevolucion } from "../../../constant/catEstatusDevolucion"
const columns = [
    { id: "1", minWidth: 50, align: "center", label: "Referencia" },
    { id: "2", minWidth: 50, align: "center", label: "Nombre" },
    { id: "3", minWidth: 50, align: "center", label: "Motivo" },
    { id: "4", minWidth: 50, align: "center", label: "Estatus" },
    { id: "5", minWidth: 50, align: "center", label: "Banco" },
    { id: "6", minWidth: 50, align: "center", label: "CLABE" },
    { id: "7", minWidth: 50, align: "center", label: "RFC" },
    { id: "8", minWidth: 50, align: "center", label: "Creado" },
    { id: "9", minWidth: 50, align: "center", label: "Documento" },
    { id: "10", minWidth: 50, align: "center", label: "Comentario" },
    { id: "11", minWidth: 50, align: "center", label: "" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TDevoluciones = () => {
    const { listDevolucionesPendientes, total, pagina, registros } = useSelector(store => store.devolucionesPendientes)
    const rows = listDevolucionesPendientes ?? []
    const classes = useStyles()
    const dispatch = useDispatch()
    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerDevolucionesPendientesPaginaAction({ Pagina: newPage })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleChangeRowsPerPage = (event) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerDevolucionesPendientesRegistrosAction({ Registros: +event.target.value })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row?.IdDevolucionSolicitud}>
                                        <TableCell align='center'>
                                            <ButtonClienteDetalle referencia={row?.Referencia} />
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${row?.Nombre} ${row?.Apellidos}`}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.CatDevolucion?.Descripcion}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.CatEstatusDevolucion?.Descripcion}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.Banco?.Nombre}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row?.CuentaClave}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row?.RFC}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {
                                                FormatoFechaIso({ date: row?.FechaRegistro, formato: "dd-MM-yyyy" })
                                            }
                                        </TableCell>
                                        <TableCell align="center">
                                            <ButtonDowloadEstadoCueta
                                                IdDevolucionSolicitud={row?.IdDevolucionSolicitud}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <DialogMensaje Mensaje={row?.Motivo} />
                                        </TableCell>
                                        <TableCell align="center">
                                            {
                                                (row?.CatEstatusDevolucion?.IdCatEstatusDevolucion === catEstatusCatEstatusDevolucion.EN_ESPERA) &&
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem" }}>
                                                    <ButtonAceptarDevolucion
                                                        IdDevolucionSolicitud={row?.IdDevolucionSolicitud}
                                                    />
                                                    <ButtonDeclinarRembolso
                                                        IdDevolucionSolicitud={row?.IdDevolucionSolicitud}
                                                    />
                                                </div>
                                            }
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={total}
                    rowsPerPage={registros}
                    page={pagina}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )
}
export default TDevoluciones